import React from "react";

// Major scale intervals (semitones from root)
const MAJOR_INTERVALS = [0, 2, 4, 5, 7, 9, 11];
const KEYS = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
// For one octave, labels of white keys & positions of black keys
const WHITE = ["C", "D", "E", "F", "G", "A", "B"];
const BLACK = [
  { name: "C#", afterIndex: 0 },
  { name: "D#", afterIndex: 1 },
  { name: "F#", afterIndex: 3 },
  { name: "G#", afterIndex: 4 },
  { name: "A#", afterIndex: 5 },
];

function scaleKeysFor(rootKey) {
  const rootIdx = KEYS.indexOf(rootKey);
  if (rootIdx < 0) return new Set();
  return new Set(MAJOR_INTERVALS.map((i) => KEYS[(rootIdx + i) % 12]));
}

export default function ScaleKeyboard({ rootKey }) {
  const activeSet = scaleKeysFor(rootKey);
  const whiteW = 60;
  const whiteH = 180;
  const blackW = 38;
  const blackH = 110;
  const totalW = whiteW * WHITE.length;

  return (
    <svg viewBox={`0 0 ${totalW} ${whiteH}`} className="w-full max-w-3xl h-auto rounded-2xl shadow-xl" data-testid="scale-keyboard">
      {/* white keys */}
      {WHITE.map((w, i) => {
        const active = activeSet.has(w);
        return (
          <g key={w}>
            <rect x={i * whiteW} y={0} width={whiteW} height={whiteH} className={`piano-key-white ${active ? "active" : ""}`} rx="3" />
            <text x={i * whiteW + whiteW / 2} y={whiteH - 14} textAnchor="middle"
                  fontFamily="Outfit" fontWeight="700" fontSize="14"
                  fill={active ? "#0a0a0a" : "#555"}>{w}</text>
          </g>
        );
      })}
      {/* black keys on top */}
      {BLACK.map((b) => {
        const x = (b.afterIndex + 1) * whiteW - blackW / 2;
        const active = activeSet.has(b.name);
        return (
          <g key={b.name}>
            <rect x={x} y={0} width={blackW} height={blackH} className={`piano-key-black ${active ? "active" : ""}`} rx="2" />
            <text x={x + blackW / 2} y={blackH - 8} textAnchor="middle"
                  fontFamily="Outfit" fontWeight="700" fontSize="10"
                  fill={active ? "#0a0a0a" : "#fff"}>{b.name}</text>
          </g>
        );
      })}
    </svg>
  );
}
